/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePresignUrlDto } from '../../models/create-presign-url-dto';
import { PresignUrlResDto } from '../../models/presign-url-res-dto';

export interface StorageControllerGetPresignedUrl$Params {
  body: CreatePresignUrlDto;
}

export function storageControllerGetPresignedUrl(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerGetPresignedUrl$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PresignUrlResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerGetPresignedUrl.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PresignUrlResDto>;
      }),
    );
}

storageControllerGetPresignedUrl.PATH = '/storage/s3/presigned-url';
